export const colors =  {
    blue:'#1B75BB',
    green:'#17BF5F',
    yellow:'#FAD961',
    grey :'#B5B5B5',
    red:'#FB5D5D'
 }